import { ArtistData } from '@/lib/artistData';
import { Instagram, Music2, Mail } from 'lucide-react';

interface ArtistSocialMediaProps {
  artist: ArtistData;
}

const ArtistSocialMedia = ({ artist }: ArtistSocialMediaProps) => {
  return (
    <section id="social" className="py-10 mb-8">
      <h2 className="text-2xl font-extrabold text-text-primary mb-6">Följ {artist.name}</h2>

      <div className="flex flex-wrap gap-3">
        {artist.instagramUrl && (
          <a
            href={artist.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 bg-white border border-border-light rounded-xl px-5 py-3 text-sm font-semibold text-text-primary hover:border-indigo-200 hover:shadow-md transition-all duration-200 hover:-translate-y-0.5"
          >
            <Instagram className="w-4 h-4 text-pink-500" />
            {artist.instagramHandle || 'Instagram'}
          </a>
        )}

        {artist.tiktokUrl && (
          <a
            href={artist.tiktokUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 bg-white border border-border-light rounded-xl px-5 py-3 text-sm font-semibold text-text-primary hover:border-indigo-200 hover:shadow-md transition-all duration-200 hover:-translate-y-0.5"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
            </svg>
            {artist.tiktokHandle || 'TikTok'}
          </a>
        )}

        {artist.spotifyUrl && (
          <a
            href={artist.spotifyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 bg-white border border-border-light rounded-xl px-5 py-3 text-sm font-semibold text-text-primary hover:border-indigo-200 hover:shadow-md transition-all duration-200 hover:-translate-y-0.5"
          >
            <Music2 className="w-4 h-4 text-[#1DB954]" />
            Spotify
          </a>
        )}

        {artist.email && (
          <a
            href={`mailto:${artist.email}`}
            className="inline-flex items-center gap-2.5 bg-white border border-border-light rounded-xl px-5 py-3 text-sm font-semibold text-text-primary hover:border-indigo-200 hover:shadow-md transition-all duration-200 hover:-translate-y-0.5"
          >
            <Mail className="w-4 h-4 text-brand-indigo" />
            E-post
          </a>
        )}
      </div>
    </section>
  );
};

export default ArtistSocialMedia;
